<template>
    <div class="w-100 h-100 d-flex flex-column">
        <b-form-select class="w-100 mb-1" :options="selectType"
                       v-model="type"></b-form-select>
        <template v-if="type === 'enum'">
            <b-button class="w-100" variant="light" @click="openModal">设置选项</b-button>
            <div v-for="item of fixedOptions" :key="item.value">
                {{ item.value }}:{{ item.text }}
            </div>
        </template>
        <template v-if="type === 'from_dict'">
            <b-form-input v-model="from" debounce="300"></b-form-input>
        </template>

        <div class="tag-config mt-2 pt-2">
            <b-form-checkbox v-model="tagEnabled">标签显示（Tag）</b-form-checkbox>
            <template v-if="tagEnabled">
                <div class="tag-config__hint text-muted">值 → 颜色（token 或 #hex，留空走中性兜底）</div>
                <div v-for="(row,i) of tagRows" :key="i"
                     class="d-flex flex-row align-items-center mt-1">
                    <template v-if="row.fromOption">
                        <div class="tag-config__label mr-1" :title="row.value">
                            {{ row.value }}<span v-if="row.text" class="text-muted">/{{ row.text }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <b-form-input class="tag-config__value mr-1" size="sm"
                                      v-model="row.value" placeholder="value"></b-form-input>
                    </template>
                    <select-tag class="mr-2" :text="row.text || row.value || '示例'" :color="row.color"/>
                    <tag-color-picker :value="row.color"
                                      @input="$set(row, 'color', $event)"/>
                    <mini-button v-if="!row.fromOption" class="ml-1" variant="light"
                                 @btnClick="removeTagRow(i)">
                        <i class="fa-solid fa-xmark"></i>
                    </mini-button>
                </div>
                <b-button size="sm" variant="light" class="mt-1" @click="addTagRow">
                    <i class="fa-solid fa-plus"></i> 值
                </b-button>
            </template>
        </div>

        <re-b-modal ref="enum" header="Select Enum">
            <mini-table read-only
                        :items="options"
                        :fields="optionEditField"
                        row-key="value"
                        effect-origin-row
                        enable-inline-edit>
                <template #leftHeader>
                    <mini-button @btnClick="openEnumImport">
                        <i class="fa-solid fa-download"></i>
                    </mini-button>
                </template>
                <template #rightHeader>
                    <b-dropdown text="Quick Set" variant="light">
                        <b-dropdown-item v-for="(item,i) of quickSet" :key="i"
                                         @click="options = deepCopyObj(item)">
                            {{ item }}
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </mini-table>
        </re-b-modal>

        <re-b-modal ref="enumImport" header="Import Enum"
                    ok-label="Import"
                    @ok="importFromEnum">
            <mini-input :value.sync="enumName" type="input" label="Enum Class Name"/>
            <b-button variant="light" class="mt-1" @click="queryEnum">
                Search
            </b-button>
            <div>
                {{ enumMap }}
            </div>
        </re-b-modal>
    </div>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import SelectTag from "@/components/common/mini-table/cells/SelectTag.vue";
import TagColorPicker from "@/components/common/mini-table/cells/TagColorPicker.vue";

export default {
    name: "SelectConfig",
    components: {TagColorPicker, SelectTag, MiniInput, MiniButton, MiniTable, ReBModal},
    mixins: [emCommonUtilMixin],
    props: {
        item: Object
    },
    data() {
        return {
            selectType: [
                {value: null, text: 'Please select type'},
                {value: 'enum', text: 'Static'},
                // {value: 'from_entity', text: 'From Entity'},
                {value: 'from_dict', text: 'Dict Enum'},
            ],
            type: null,
            options: [],
            optionEditField: [
                {key: 'value', label: 'Value', type: 'input'},
                {key: 'text', label: 'Label', type: 'input'},
            ],
            from: null,

            enumName: null,
            enumMap: {},

            quickSet: [
                [{value: 'true', text: '是'}, {value: 'false', text: '否'},],
                [{value: '1', text: '是'}, {value: '0', text: '否'},]
            ],

            tagRows: [],
        }
    },
    computed: {
        fixedOptions() {
            let tempList = [];
            for (let item of this.options) {
                tempList.push({
                    value: item.value,
                    text: item.text
                })
            }
            return tempList;
        },
        tagEnabled: {
            get() {
                return !!(this.item && this.item.tag);
            },
            set(val) {
                this.$set(this.item, 'tag', val ? true : undefined);
            }
        },
    },
    watch: {
        item: {
            handler(val, old) {
                if (val && (!old || val.key !== old.key)) {
                    if (this.item.optionsFromDict) {
                        this.type = 'from_dict';
                        this.from = this.item.optionsFromDict;
                    }
                    if (this.item.options) {
                        this.type = 'enum';
                        this.options = this.item.options;
                    }
                    this.initTagRows();
                }
            },
            immediate: true
        },
        fixedOptions() {
            if (this.type === 'enum') {
                this.$set(this.item, 'options', this.fixedOptions);
                this.$set(this.item, 'optionsFromDict', undefined);
            }
            this.initTagRows();
        },
        tagRows: {
            handler() {
                this.syncTagColors();
            },
            deep: true
        },
        from: {
            handler() {
                if (this.type === 'from_dict') {
                    this.$set(this.item, 'options', undefined);
                    this.$set(this.item, 'optionsFromDict', this.from);
                }
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        openModal() {
            this.$refs.enum.showModal();
        },
        openEnumImport() {
            this.$refs.enumImport.showModal();
        },
        queryEnum() {
            let service = this.$store.state.queryConfigStore.currentService;
            if (service && this.enumName) {
                this.$store.dispatch('api/get', {
                    url: `${process.env.VUE_APP_EM_GATEWAY_URL}/${service}/qg/get/enum?enumClass=${this.enumName}`
                }).then(res => {
                    if (res) {
                        this.enumMap = res;
                    }
                });
            }
        },
        importFromEnum() {
            if (this.enumMap) {
                for (let key of Object.keys(this.enumMap)) {
                    this.options.push({
                        value: key,
                        text: this.enumMap[key]
                    })
                }
            }
        },
        initTagRows() {
            let existing = (this.item && this.item.tagColors) || {};
            let rows = [];
            let seen = new Set();
            // 静态 options 派生行：value 只读，颜色可编辑
            for (let op of this.fixedOptions) {
                rows.push({
                    value: op.value,
                    text: op.text,
                    color: existing[op.value] || '',
                    fromOption: true
                });
                seen.add('' + op.value);
            }
            // 已配置但不在 options 中的值（如 Dict 枚举）：value 可编辑
            for (let key of Object.keys(existing)) {
                if (!seen.has('' + key)) {
                    rows.push({value: key, text: '', color: existing[key], fromOption: false});
                }
            }
            this.tagRows = rows;
        },
        syncTagColors() {
            let map = {};
            for (let row of this.tagRows) {
                let v = row.value;
                if (v !== null && v !== undefined && ('' + v).trim() !== '' && row.color) {
                    map[v] = row.color;
                }
            }
            this.$set(this.item, 'tagColors', Object.keys(map).length > 0 ? map : undefined);
        },
        addTagRow() {
            this.tagRows.push({value: '', text: '', color: '', fromOption: false});
        },
        removeTagRow(i) {
            this.tagRows.splice(i, 1);
        },
    }
}
</script>

<style scoped>
.tag-config {
    border-top: 1px solid #e7edf3;
}

.tag-config__hint {
    font-size: 12px;
}

.tag-config__label {
    min-width: 88px;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tag-config__value {
    width: 96px;
}
</style>
